import React,{useState, useEffect} from "react";
import {fire} from "../../firebase/config";
import {facebookProvider} from "../../firebase/config";

import VkAuth from 'react-vk-auth';

const ok=window.OKSDK
const VK = window.VK
// firebase.initializeApp({
//   apikey:"AIzaSyBF1nUZrvs9WgXLUk3uiA1vOlFuGuFFxzI",
//   authDomain:"redslon.firebaseapp.com"
// })

function Modal(props) {

 
  const [form, setForm] = useState({ email: "", password: "" });


const loginWithVk =()=>{

  VK.Auth.login(r => {
    if (r.session) {
      setForm({email:r.session.user.id+"@mail.ru",password:r.session.user.id+2400})
      loginHandler()
    } else {
     
    }
  })

}
 const loginWithOk=()=>{
  ok.REST.call(
    "users.getCurrentUser", 
    null,
    function (status, data, error) {
        if (status == "ok") {
            console.log(data);
        }
       
        if (status == "error") {
            console.log("Error: " + JSON.stringify(error));
        }
    }
);
 }
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    console.log(form);
  };

  const handleClose=(e)=>{
    console.log(e.target.id);
    if(e.target.id==="upmodal"){
      props.closeFu()
    }
  }

const loginWithFb=()=>{

    fire.auth().signInWithPopup(facebookProvider)
    .then((result)=>{
      console.log(result);
      fire
    .database()
    .ref("/users/" + result.user.uid)
    .once("value")
      .then((snapshot) => {
        
       let res = snapshot.val();
     
       if(!res){
        fire
        .database()
        .ref("/users/" + result.user.uid)
        .set({
         name:result.additionalUserInfo.profile.first_name,
         balance:0
        }).then(()=>console.log("ok"))
        .catch(()=>console.log("errr"))
       }
      })
    })
    
   
}

  const loginHandler = async () => {
    fire
      .auth()
      .signInWithEmailAndPassword(form.email, form.password)
      .then((u) => {
        console.log("ok")
        
      })
      .catch(() => {
       console.log("error")
      });
   
  };
  return (
    <div onClick={handleClose} class="upmodal" id="upmodal">
      <div class="upmodal__content">
        <div class="close__up"></div>
        <div class="upmodal_rcontent">
          <div class="upmodal__icon d-flex">
            <img src="img/user.png" alt="user" />
          </div>
          <form action="#" class="upmodal__form upmodal-form">
            <div class="upmodal-form__box-name">
              <input
                type="text"
                name="email"
                class="upmodal-form__name"
                placeholder="Имя Пользователя"
                onChange={handleChange}
              />
            </div>
            <div class="upmodal-form__box-password">
              <input
                type="text"
                class="upmodal-form__password"
                placeholder="Пароль"
                name="password"
                onChange={handleChange}
              />
            </div>
            
            <button onClick={loginHandler} class="upmodal__btn">Войти</button>
            <div class="upmodal-form__forget">
              <div class="upmodal-form-ff">
                <input
                  type="checkbox"
                  class="upmodal-form__checked"
                  id="upmodal-form__checked"
                />
                <label for="upmodal-form__checked">Запомнить меня</label>
              </div>
              <a href="#" class="upmodal__btngo">
                Забыли пароль?
              </a>
            </div>
            <div class="upmodal-form__goin">Или быстро войти через соцсети</div>
            <div class="upmodal-form__icons d-flex">
              <div class="modalup__icon"  onClick={loginWithVk}>
                <img src="img/modalsoc1.svg" alt="icon" />
              </div>
              <div class="modalup__icon" onClick={loginWithFb}>
                <img src="img/modalsoc2.svg" alt="icon" />
              </div>
              <div class="modalup__icon" onClick={loginWithOk}>
                <img src="img/modalsoc3.svg" alt="icon" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Modal;
